package com.example.readingnotes.platform

/**
 * Platform-specific key-value storage interface
 * Used for persisting user preferences like search settings
 */
interface KeyValueStorage {
    fun getString(key: String, defaultValue: String? = null): String?

    fun setString(key: String, value: String?)

    fun getInt(key: String, defaultValue: Int): Int

    fun setInt(key: String, value: Int)

    fun getBoolean(key: String, defaultValue: Boolean): Boolean

    fun setBoolean(key: String, value: Boolean)

    fun remove(key: String)

    fun clear()
}

/**
 * Search settings data class
 */
data class SearchSettings(
    val pageSize: Int = 20,
    val sortBy: String = "newest",
    val statusFilter: String? = null,
    val autoSearch: Boolean = true,
)

/**
 * Favorite search query
 */
data class FavoriteSearch(
    val name: String,
    val query: String,
    val tags: Set<String> = emptySet(),
    val status: String? = null,
    val createdAt: String,
)

expect fun createKeyValueStorage(): KeyValueStorage
